import React, { useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  Chip,
  Box,
  IconButton,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";

const Accepted = ({ forbatch, acceptedBatches, setAcceptedBatches }) => {
  const [expandedBatch, setExpandedBatch] = React.useState(null);

  const handleAccordionToggle = (batchTitle) => (event) => {
    event.stopPropagation();
    setExpandedBatch((prev) => (prev === batchTitle ? null : batchTitle));
  };

  // Handle the logic to update batches with jobs
  useEffect(() => {
    if (forbatch && acceptedBatches.length > 0) {
      const updatedBatches = acceptedBatches.map((batch) => ({
        ...batch,
        jobs: [],
      }));

      forbatch.forEach((job) => {
        const batch = updatedBatches.find(
          (batch) => batch._id === job.batchOfJobsForInstallationPartnerId
        );
        if (batch) {
          batch.jobs.push(job);
        }
      });

      // Calculate the date range for each batch
      updatedBatches.forEach((batch) => {
        if (batch.jobs.length > 0) {
          const jobDates = batch.jobs.map(
            (job) => new Date(job.jobStartingDate)
          );
          const completionDates = batch.jobs.map(
            (job) => new Date(job.jobCompletionDate)
          );

          const earliestDate = new Date(
            Math.min(...jobDates.map((date) => date.getTime()))
          );
          const latestDate = new Date(
            Math.max(...completionDates.map((date) => date.getTime()))
          );

          batch.dateRange = `${earliestDate.toLocaleDateString()} - ${latestDate.toLocaleDateString()}`;
        } else {
          batch.dateRange = "No Dates Available";
        }
      });

      setAcceptedBatches((prevBatches) => {
        const prevBatchesString = JSON.stringify(prevBatches);
        const updatedBatchesString = JSON.stringify(updatedBatches);

        if (prevBatchesString !== updatedBatchesString) {
          return updatedBatches;
        } else {
          return prevBatches;
        }
      });
    }
  }, [forbatch, acceptedBatches, setAcceptedBatches]);

  console.log("acceptedinAudit", acceptedBatches);
  return (
    <Grid className={`${styles.scrollableContainer}`}>
      {acceptedBatches?.length > 0 &&
      acceptedBatches.some(
        (batch) => !batch.jobs?.every((job) => job.status === 2)
      ) ? (
        acceptedBatches
          .filter((batch) => !batch.jobs?.every((job) => job.status === 2)) // Filter out batches with all jobs completed
          .map((batch, index) => (
            <Grid item xs={12} md={12} key={index} my={1} mx={2}>
              <Accordion expanded={expandedBatch === batch.batchTitle}>
                <AccordionSummary
                  expandIcon={
                    <IconButton
                      onClick={handleAccordionToggle(batch.batchTitle)}
                    >
                      <ExpandMoreIcon />
                    </IconButton>
                  }
                  aria-controls={`panel-${index}-content`}
                  id={`panel-${index}-header`}
                >
                  <div className="flex items-center justify-between p-4 rounded-lg bg-white w-full mx-auto">
                    {/* Section 1: Batch Title */}
                    <div className="flex">
                      <h1 className={`${styles.batchTitle}`}>
                        {batch.batchTitle}
                      </h1>
                    </div>

                    {/* Section 2: Other Details */}
                    <div className="flex items-center gap-6">
                      {/* Date Range */}
                      <Chip label={batch.dateRange} className={styles.chip} />

                      {/* User Info */}
                      <Chip label={batch.contact} className={styles.chip} />

                      {/* Status Badge */}
                      <Chip label={batch.status} className={styles.pending} />

                      {/* Ellipsis Button */}
                      <button className="text-gray-400 hover:text-gray-600 text-xl">
                        ⋮
                      </button>
                    </div>
                  </div>
                </AccordionSummary>

                <AccordionDetails className={styles.accordionDetails}>
                  {/* Render Job Details Table */}
                  <Box className={`${styles.scrollableBox}`}>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead>
                          <TableRow className={styles.tableHeader}>
                            <TableCell className={styles.tableCell}>
                              ADDRESS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              STORE MANAGER
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              JOB DATE
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              JOB PAY
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              KAM APPROVAL
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              SITE REPORT
                            </TableCell>

                            <TableCell className={styles.tableCell}>
                              JOBSTATUS
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              IP PAY
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {batch?.jobs?.map((row, index) => (
                            <TableRow key={index}>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.address}
                                </div>
                                <div className={styles.address2}>
                                  {row.address2}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.storeOwnerName}
                                </div>
                                <div className={styles.storeManagerContact}>
                                  {row.storeOwnerPhoneNumber}
                                </div>
                              </TableCell>

                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.jobDate}
                                </div>
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  ₹{row.jobPay}
                                </div>
                              </TableCell>

                              <TableCell className={styles.tableCell}>
                                <div className={styles.sharedTextStyle}>
                                  {row.kamApproval}
                                </div>
                              </TableCell>

                              <TableCell className={styles.tableCell}>
                                <div className={styles.linkWithImage}>
                                  <img
                                    src={PdfIcon}
                                    alt="PDF Icon"
                                    className={styles.icon}
                                  />
                                  <a href="#" className={styles.link}>
                                    {row.SiteReport}
                                  </a>
                                </div>
                              </TableCell>

                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={row.jobStatus}
                                  className={styles.pending}
                                />
                              </TableCell>
                              <TableCell className={styles.tableCell}>
                                <Chip
                                  label={row.ipPay}
                                  className={styles.pending}
                                />
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Grid>
          ))
      ) : (
        <Typography
          variant="h6"
          align="center"
          className={`${styles.noJobsBox} ${styles.noJobsText}`}
        >
          No Batch of Jobs Available
        </Typography>
      )}
    </Grid>
  );
};

export default Accepted;
